import tw, { styled } from 'twin.macro';
import { standardHorizontalPadding } from '../../layouts/wrapper-layout';

export const HomePageWrapper = styled.div(() => [tw`w-full`, standardHorizontalPadding]);
